"use client";
import React from 'react';
import '../css/SsostaaiPage.css';
import '../root.css';
import SEO from '../components/SEO';

function SsostaaiPage() {
  return (
    <>
      <SEO
        title="SSOSTA AI - Product Launch Video | Samuel Banczík"
        description="SSOSTA AI is a fine-tuned OpenAI chatbot built by Samuel Banczík that answers questions about his high school. This page shows the cinematic product launch film created for the platform."
        keywords="SSOSTA AI, artificial intelligence, AI solution, machine learning, Samuel Banczík"
        url="https://banczik.com/ssostaai"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "SSOSTA AI",
          // The entity lives on its own domain; this page only describes it.
          "url": "https://ssostaai.banczik.com",
          "sameAs": "https://ssostaai.banczik.com",
          "mainEntityOfPage": "https://banczik.com/ssostaai",
          "applicationCategory": "CommunicationApplication",
          "operatingSystem": "Web",
          "author": {
            "@type": "Person",
            "name": "Samuel Banczík",
            "url": "https://banczik.com"
          },
          "description": "AI-powered solution leveraging modern technology to solve real-world problems",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
              { "@type": "ListItem", "position": 2, "name": "Ssosta AI", "item": "https://banczik.com/ssostaai" }
            ]
          }
        }}
      />
      <div className='ssostaai-container'>
        <div className="video-container">
          <video src="/videos/ssostaai.mp4" autoPlay loop></video>
        </div>
      </div>
    </>
  )
}

export default SsostaaiPage
